// frontend/src/modules/invoicing/components/ClientPicker.tsx
import * as React from 'react';
import { useApi } from '../../../design-system/useApi';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import type { Client } from '../types';

interface ClientPickerProps {
  value: string | null;
  onChange: (clientId: string) => void;
  disabled?: boolean;
}

export function ClientPicker({ value, onChange, disabled }: ClientPickerProps) {
  const { data, loading } = useApi<{ clients: Client[] }>('/api/invoicing/clients');
  return (
    <Select value={value ?? undefined} onValueChange={onChange} disabled={disabled || loading}>
      <SelectTrigger><SelectValue placeholder={loading ? 'Loading clients…' : 'Pick a client…'} /></SelectTrigger>
      <SelectContent>
        {(data?.clients ?? []).map((c) => (
          <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
